(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[465],{

/***/ 6430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PillButton_PillButton; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 2 modules
var gsap = __webpack_require__(6038);
// EXTERNAL MODULE: ./components/PillButton/PillButton.module.scss
var PillButton_module = __webpack_require__(502);
var PillButton_module_default = /*#__PURE__*/__webpack_require__.n(PillButton_module);
// EXTERNAL MODULE: ./components/Cursor/Cursor.js
var Cursor = __webpack_require__(6972);
// EXTERNAL MODULE: ./store/index.js + 2 modules
var store = __webpack_require__(6911);
;// CONCATENATED MODULE: ./assets/svgs/info.svg
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgInfo(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 16a7.5 7.5 0 100-15 7.5 7.5 0 000 15zm0 1a8.5 8.5 0 100-17 8.5 8.5 0 000 17z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 7v6H8V7h1zM9 4v2H8V4h1z",
    fill: "currentColor"
  })));
}
/* harmony default export */ var info = (SvgInfo);
// EXTERNAL MODULE: ./hooks/use-breakpoint.js
var use_breakpoint = __webpack_require__(694);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/PillButton/PillButton.js













var PillButton = function PillButton(_ref) {
  var className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      label = _ref.label,
      _onClick = _ref.onClick,
      _onMouseEnter = _ref.onMouseEnter,
      _onMouseLeave = _ref.onMouseLeave,
      theme = _ref.theme,
      type = _ref.type,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? 'button' : _ref$element,
      elementRef = _ref.elementRef;

  var _useState = (0,react.useState)(false),
      isHover = _useState[0],
      setIsHover = _useState[1];

  var textRefs = (0,react.useRef)([]);
  var setCursorType = (0,store/* default */.ZP)(function (state) {
    return state.setCursorType;
  });
  var Element = element;

  var _useBreakpoint = (0,use_breakpoint/* default */.Z)(),
      isMobile = _useBreakpoint.isMobile;

  (0,react.useEffect)(function () {
    if (!textRefs.current.length || isMobile) return;
    setCursorType(isHover ? Cursor/* STATES.hover */.P.hover : Cursor/* STATES.static */.P["static"]);
    gsap/* default.killTweensOf */.ZP.killTweensOf(textRefs.current);
    gsap/* default.to */.ZP.to(textRefs.current, {
      y: function y(i) {
        var y = i === 0 ? '-110%' : '-100%';
        return isHover ? y : '0';
      },
      duration: 0.3,
      ease: 'Power3.easeOut'
    });
  }, [isHover, setCursorType, isMobile]);
  if (!label) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Element, {
    onMouseEnter: function onMouseEnter() {
      setIsHover(true);
      if (_onMouseEnter) _onMouseEnter();
    },
    onMouseLeave: function onMouseLeave() {
      setIsHover(false);
      if (_onMouseLeave) _onMouseLeave();
    },
    "aria-label": ariaLabel ? ariaLabel : undefined,
    className: classnames_default()((PillButton_module_default()).PillButton, className, (0,defineProperty/* default */.Z)({}, (PillButton_module_default())[theme], theme), (0,defineProperty/* default */.Z)({}, (PillButton_module_default()).infoButton, type === 'infoButton')),
    onClick: function onClick() {
      if (_onClick) _onClick();
    },
    ref: elementRef,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      ref: function ref(_ref2) {
        textRefs.current[0] = _ref2;
      },
      className: (PillButton_module_default()).text,
      children: [label, type === 'infoButton' && /*#__PURE__*/(0,jsx_runtime.jsx)(info, {
        className: (PillButton_module_default()).infoIcon
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      ref: function ref(_ref3) {
        textRefs.current[1] = _ref3;
      },
      className: (PillButton_module_default()).textHover,
      children: [label, type === 'infoButton' && /*#__PURE__*/(0,jsx_runtime.jsx)(info, {
        className: (PillButton_module_default()).infoIcon
      })]
    })]
  });
};

PillButton.displayName = 'PillButton';
/* harmony default export */ var PillButton_PillButton = (PillButton);

/***/ }),

/***/ 8465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Sections_Sections; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@portabletext/react/dist/react-portable-text.esm.js + 1 modules
var react_portable_text_esm = __webpack_require__(4217);
// EXTERNAL MODULE: ./components/RichText/RichText.module.scss
var RichText_module = __webpack_require__(7014);
var RichText_module_default = /*#__PURE__*/__webpack_require__.n(RichText_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./store/index.js + 2 modules
var store = __webpack_require__(6911);
// EXTERNAL MODULE: ./utils/analytics.js
var analytics = __webpack_require__(4890);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Link/Link.js






var Link = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      link = _ref.link,
      _onMouseEnter = _ref.onMouseEnter,
      _onMouseLeave = _ref.onMouseLeave,
      linkOnly = _ref.linkOnly;
  var linkType = link.linkType,
      label = link.label,
      url = link.link;
  var setCursorType = (0,store/* default */.ZP)(function (state) {
    return state.setCursorType;
  });
  if (linkType === 'Internal' && !(url !== null && url !== void 0 && url.slug)) return null;
  if (linkType === 'External' && !url) return null;

  var handleClick = function handleClick() {
    (0,analytics/* event */.B)({
      action: 'clicked_link',
      params: {
        link: linkType === 'External' ? link : "/".concat(url.slug)
      }
    });
  };

  if (linkType === 'External') {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
      ref: ref,
      onClick: handleClick,
      href: url,
      className: classnames_default()(className),
      target: "_blank",
      rel: "noreferrer",
      onMouseEnter: function onMouseEnter() {
        if (_onMouseEnter) _onMouseEnter();
        setCursorType('hover');
      },
      onMouseLeave: function onMouseLeave() {
        if (_onMouseLeave) _onMouseLeave();
        setCursorType('static');
      },
      children: [label && !children && !linkOnly && label, children && children]
    });
  } else if (linkType === 'Internal') {
    var slug = url.slug;

    if (slug === 'home') {
      slug = '';
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)((link_default()), {
      ref: ref,
      onClick: handleClick,
      className: classnames_default()(className),
      href: "/".concat(slug),
      scroll: false,
      onMouseEnter: function onMouseEnter() {
        if (_onMouseEnter) _onMouseEnter();
      },
      onMouseLeave: function onMouseLeave() {
        if (_onMouseLeave) _onMouseLeave();
      },
      children: [label && !children && label, children && children]
    });
  }
});
Link.displayName = 'Link';
/* harmony default export */ var Link_Link = (Link);
;// CONCATENATED MODULE: ./components/RichText/RichText.js





var portableTextSerializer = {
  marks: {
    link: function link(_ref) {
      var value = _ref.value;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Link_Link, {
        link: value
      });
    },
    highlighted: function highlighted(_ref2) {
      var children = _ref2.children;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (RichText_module_default()).highlighted,
        children: children
      });
    },
    displayText: function displayText(_ref3) {
      var children = _ref3.children;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (RichText_module_default()).displayText,
        children: children
      });
    }
  }
};

function RichText(_ref4) {
  var className = _ref4.className,
      content = _ref4.content;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()((RichText_module_default()).RichText, className),
    "data-component": "RichText",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_portable_text_esm/* PortableText */.YI, {
      value: content,
      components: portableTextSerializer
    })
  });
}

/* harmony default export */ var RichText_RichText = (RichText);
// EXTERNAL MODULE: ./components/SanityImage/SanityImage.js + 14 modules
var SanityImage = __webpack_require__(905);
// EXTERNAL MODULE: ./components/_modules/HomeSettings/AboutModal/AboutModal.module.scss
var AboutModal_module = __webpack_require__(6914);
var AboutModal_module_default = /*#__PURE__*/__webpack_require__.n(AboutModal_module);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 2 modules
var gsap = __webpack_require__(6038);
// EXTERNAL MODULE: ./components/CursorHover/CursorHover.module.scss
var CursorHover_module = __webpack_require__(2030);
var CursorHover_module_default = /*#__PURE__*/__webpack_require__.n(CursorHover_module);
;// CONCATENATED MODULE: ./components/CursorHover/CursorHover.js





var CursorHover = function CursorHover(_ref) {
  var className = _ref.className,
      children = _ref.children,
      cursorType = _ref.cursorType,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? 'div' : _ref$element;
  var setCursorType = (0,store/* default */.ZP)(function (state) {
    return state.setCursorType;
  });
  var Element = element;
  if (!cursorType) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Element, {
    onMouseEnter: function onMouseEnter() {
      setCursorType(cursorType);
    },
    onMouseLeave: function onMouseLeave() {
      setCursorType(null);
    },
    className: classnames_default()((CursorHover_module_default()).CursorHover, className),
    children: children
  });
};

CursorHover.displayName = 'CursorHover';
/* harmony default export */ var CursorHover_CursorHover = (CursorHover);
// EXTERNAL MODULE: ./hooks/use-page-transition.js
var use_page_transition = __webpack_require__(7073);
// EXTERNAL MODULE: ./components/Transition/Transition.js + 190 modules
var Transition = __webpack_require__(6662);
;// CONCATENATED MODULE: ./components/_modules/HomeSettings/AboutModal/AboutModal.js














var AboutModal = function AboutModal(_ref) {
  var _people$names;

  var className = _ref.className,
      buttonText = _ref.buttonText,
      richTextContent = _ref.richTextContent,
      image = _ref.image,
      people = _ref.people,
      contactMethods = _ref.contactMethods,
      aboutModalIsOpen = _ref.aboutModalIsOpen,
      setAboutModalIsOpen = _ref.setAboutModalIsOpen;
  var containerRef = (0,react.useRef)();
  var buttonRef = (0,react.useRef)();
  var bgRef = (0,react.useRef)();

  var _usePageTransition = (0,use_page_transition/* default */.Z)(),
      pageState = _usePageTransition.pageState;

  (0,react.useEffect)(function () {
    if (!buttonRef.current) return;
    gsap/* default.killTweensOf */.ZP.killTweensOf(buttonRef.current);

    if (pageState === 'in') {
      gsap/* default.fromTo */.ZP.fromTo(buttonRef.current, {
        y: -50,
        autoAlpha: 0
      }, {
        y: 0,
        autoAlpha: 1,
        duration: Transition/* TRANSITION_TIME */.aV * 0.5,
        delay: Transition/* TRANSITION_TIME */.aV
      });
    } else {
      gsap/* default.to */.ZP.to(buttonRef.current, {
        y: -50,
        autoAlpha: 0,
        duration: Transition/* TRANSITION_TIME */.aV * 0.5
      });
    }
  }, [pageState]);
  (0,react.useEffect)(function () {
    if (!containerRef.current || !bgRef.current) return;
    gsap/* default.killTweensOf */.ZP.killTweensOf(containerRef.current);
    gsap/* default.to */.ZP.to(containerRef.current, {
      x: aboutModalIsOpen ? '0%' : '-130%',
      duration: aboutModalIsOpen ? 0.8 : 0.4,
      rotate: aboutModalIsOpen ? '0deg' : '-10deg',
      ease: 'Power3.easeOut'
    });
    gsap/* default.set */.ZP.set(bgRef.current, {
      display: aboutModalIsOpen ? 'block' : 'none'
    });
  }, [aboutModalIsOpen]);
  if (!buttonText || !richTextContent || !image || !contactMethods.length || !people) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (AboutModal_module_default()).aboutModalBg,
      ref: bgRef,
      onClick: function onClick() {
        setAboutModalIsOpen(false);
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      ref: containerRef,
      className: classnames_default()((AboutModal_module_default()).AboutModal, className),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (AboutModal_module_default()).inner,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (AboutModal_module_default()).close,
          "aria-label": "Close About Modal",
          onClick: function onClick() {
            setAboutModalIsOpen(false);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CursorHover_CursorHover, {
            className: (AboutModal_module_default()).closeInner,
            element: "span",
            cursorType: "hover",
            children: "[x]"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (AboutModal_module_default()).innerScroll,
          "data-lenis-prevent": true,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (AboutModal_module_default()).rta,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(RichText_RichText, {
              content: richTextContent
            })
          }), (people === null || people === void 0 ? void 0 : people.title) && (people === null || people === void 0 ? void 0 : (_people$names = people.names) === null || _people$names === void 0 ? void 0 : _people$names.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (AboutModal_module_default()).peopleContainer,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
              className: (AboutModal_module_default()).peopleTitle,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: people.title
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                children: ["[", people.names.length, "]"]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              className: (AboutModal_module_default()).peopleList,
              children: people.names.map(function (person, i) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: (AboutModal_module_default()).peopleList__item,
                  children: person !== null && person !== void 0 && person.websiteLink ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    href: person.websiteLink,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CursorHover_CursorHover, {
                      element: "span",
                      cursorType: "hover",
                      children: person === null || person === void 0 ? void 0 : person.name
                    })
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: person === null || person === void 0 ? void 0 : person.name
                  })
                }, i);
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (AboutModal_module_default()).imageContainer,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(SanityImage/* default */.Z, {
                unoptimized: true,
                image: image,
                className: (AboutModal_module_default()).image
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: (AboutModal_module_default()).contactMethods,
          children: contactMethods.map(function (method, i) {
            if (!method.type || !method.link) return null;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: (AboutModal_module_default()).contactMethods__method,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (AboutModal_module_default()).contactMethods__type,
                children: method.type
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (AboutModal_module_default()).contactMethods__value,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link_Link, {
                  link: method.link
                })
              })]
            }, i);
          })
        })]
      })
    })]
  });
};

AboutModal.displayName = 'AboutModal';
/* harmony default export */ var AboutModal_AboutModal = (AboutModal);
// EXTERNAL MODULE: ./components/_modules/HomeSettings/Footer/Footer.module.scss
var Footer_module = __webpack_require__(4471);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
// EXTERNAL MODULE: ./components/Ticker/Ticker.js
var Ticker = __webpack_require__(9775);
;// CONCATENATED MODULE: ./components/_modules/HomeSettings/Footer/Footer.js












var Footer = function Footer(_ref) {
  var className = _ref.className,
      brandName = _ref.brandName,
      copyright = _ref.copyright,
      longText = _ref.longText;
  var portfolioItemHoverIndex = (0,store/* default */.ZP)(function (state) {
    return state.portfolioItemHoverIndex;
  });

  var _usePageTransition = (0,use_page_transition/* default */.Z)(),
      pageState = _usePageTransition.pageState;

  var containerRef = (0,react.useRef)();
  (0,react.useEffect)(function () {
    if (!containerRef.current) return;
    gsap/* default.killTweensOf */.ZP.killTweensOf(containerRef.current);

    if (pageState === 'in') {
      gsap/* default.fromTo */.ZP.fromTo(containerRef.current, {
        autoAlpha: 0
      }, {
        autoAlpha: 1,
        duration: 0.5,
        delay: Transition/* TRANSITION_TIME */.aV
      });
    } else {
      gsap/* default.to */.ZP.to(containerRef.current, {
        autoAlpha: 0,
        duration: Transition/* TRANSITION_TIME */.aV
      });
    }
  }, [pageState]);
  if (!brandName || !copyright || !longText) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("footer", {
    ref: containerRef,
    className: classnames_default()((Footer_module_default()).Footer, className, (0,defineProperty/* default */.Z)({}, (Footer_module_default()).isHovering, portfolioItemHoverIndex !== false)),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Footer_module_default()).brand,
      children: brandName
    }), longText && /*#__PURE__*/(0,jsx_runtime.jsx)(Ticker/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Footer_module_default()).longText,
        children: longText
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Footer_module_default()).copyright,
      children: copyright
    })]
  });
};

Footer.displayName = 'Footer';
/* harmony default export */ var Footer_Footer = (Footer);
// EXTERNAL MODULE: ./components/PillButton/PillButton.js + 1 modules
var PillButton = __webpack_require__(6430);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 5 modules
var toConsumableArray = __webpack_require__(6687);
// EXTERNAL MODULE: ./components/_modules/HomeSettings/PortfolioItemScroller/PortfolioItemScroller.module.scss
var PortfolioItemScroller_module = __webpack_require__(3522);
var PortfolioItemScroller_module_default = /*#__PURE__*/__webpack_require__.n(PortfolioItemScroller_module);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./components/_modules/HomeSettings/PortfolioItemThumbnail/PortfolioItemThumbnail.module.scss
var PortfolioItemThumbnail_module = __webpack_require__(61);
var PortfolioItemThumbnail_module_default = /*#__PURE__*/__webpack_require__.n(PortfolioItemThumbnail_module);
// EXTERNAL MODULE: ./hooks/use-new-key-on-window-resize.js
var use_new_key_on_window_resize = __webpack_require__(2143);
// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollTrigger.js
var ScrollTrigger = __webpack_require__(6546);
// EXTERNAL MODULE: ./styles/export-vars.module.scss
var export_vars_module = __webpack_require__(763);
;// CONCATENATED MODULE: ./assets/images/explicit.png
/* harmony default export */ var explicit = ({"src":"/_next/static/media/explicit.b81b3d82.png","height":511,"width":677,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAYFBMVEU6OjoeHh4oKChQUFDGxsbb29sBAQHu7u7Q0NDY2NjY2Nivr6/i4uLCwsLQ0ND19fXe3t5BQUHBwcF8fHyLi4vt7e3g4OBra2vb29sVFRU7OzsVFRV7e3vo6Oijo6O1tbUrCvfRAAAAHHRSTlMDzKf+lf5KB8bV59kS2/40bn2++0LdZZ+kePgwrsjgIgAAAAlwSFlzAAA3XQAAN10BGYBGXQAAADlJREFUeJwFwQkCgBAAAMF106XQjf7/y2YAFxY/OYqOY5+vg9RWP5h+opsJ+6cEW861qkdihbztCz9D4gKI7KrEvwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
// EXTERNAL MODULE: ./components/Layout/Layout.js + 3 modules
var Layout = __webpack_require__(2528);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./hooks/use-breakpoint.js
var use_breakpoint = __webpack_require__(694);
;// CONCATENATED MODULE: ./components/_modules/HomeSettings/PortfolioItemThumbnail/PortfolioItemThumbnail.js






















var PATTERN_INTERVAL = parseInt(export_vars_module.patternInterval);
var PARALLAX_SPEEDS = [1.4, 1, 0.8, 1, 1, 1.3, 1, 1.3, 1];
var PARALLAX_SPEEDS_MOBILE = [1.2, 1, 0.8, 1, 1, 1.1, 1, 0.8, 1];
var ANIMATE_UP_UNTIL_INDEX = 4;
var getPatternIndexFromIndex = function getPatternIndexFromIndex(index) {
  return index % PATTERN_INTERVAL;
};
ScrollTrigger.ScrollTrigger.config({
  ignoreMobileResize: true
});
gsap/* default.registerPlugin */.ZP.registerPlugin(ScrollTrigger.ScrollTrigger);

var PortfolioItemThumbnail = function PortfolioItemThumbnail(_ref) {
  var className = _ref.className,
      slug = _ref.slug,
      title = _ref.title,
      hasExplicitContent = _ref.hasExplicitContent,
      thumbnailOptions = _ref.thumbnailOptions,
      index = _ref.index,
      setAnimateInComplete = _ref.setAnimateInComplete,
      animateInComplete = _ref.animateInComplete,
      videoUrl = _ref.videoUrl,
      type = _ref.type,
      images = _ref.images,
      videoLength = _ref.videoLength;
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      hasTicker = _useState[0],
      setHasTicker = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isInView = _useState2[0],
      setIsInView = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isHovering = _useState3[0],
      setIsHovering = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      scrollTriggerIsSetup = _useState4[0],
      setScrollTriggerIsSetup = _useState4[1];

  var metaDataTitleContainerRef = (0,react.useRef)();
  var metaDataBgRef = (0,react.useRef)();
  var titleContainerRef = (0,react.useRef)();
  var titleRef = (0,react.useRef)();
  var metaDataRef = (0,react.useRef)();
  var containerRef = (0,react.useRef)();
  var imageContainerInnerRef = (0,react.useRef)();
  var imageScaleRef = (0,react.useRef)();
  var innerTransformContainerRef = (0,react.useRef)();
  var scrollTriggerRef = (0,react.useRef)();
  var imageContainerRef = (0,react.useRef)();
  var timelineRef = (0,react.useRef)();
  var contentRef = (0,react.useRef)();
  var tickerRef = (0,react.useRef)();
  var videoRef = (0,react.useRef)();
  var explicitBadgeRef = (0,react.useRef)();
  var explicitBadgeTimelineRef = (0,react.useRef)();
  var setPortfolioItemHoverIndex = (0,store/* default */.ZP)(function (state) {
    return state.setPortfolioItemHoverIndex;
  });
  var portfolioItemHoverIndex = (0,store/* default */.ZP)(function (state) {
    return state.portfolioItemHoverIndex;
  });
  var setPortfolioItemClicked = (0,store/* default */.ZP)(function (state) {
    return state.setPortfolioItemClicked;
  });
  var portfolioItemClicked = (0,store/* default */.ZP)(function (state) {
    return state.portfolioItemClicked;
  });
  var setCenteredPortfolioItemIndex = (0,store/* default */.ZP)(function (state) {
    return state.setCenteredPortfolioItemIndex;
  });
  var centeredPortfolioItemIndex = (0,store/* default */.ZP)(function (state) {
    return state.centeredPortfolioItemIndex;
  });
  var patternIndex = getPatternIndexFromIndex(index);
  var setCursorType = (0,store/* default */.ZP)(function (state) {
    return state.setCursorType;
  });
  var breakpoint = (0,store/* default */.ZP)(function (state) {
    return state.breakpoint;
  });

  var _usePageTransition = (0,use_page_transition/* default */.Z)(),
      pageState = _usePageTransition.pageState;

  var prevPath = (0,store/* default */.ZP)(function (state) {
    return state.prevPath;
  });

  var _useBreakpoint = (0,use_breakpoint/* default */.Z)(),
      isMobile = _useBreakpoint.isMobile;

  var videoInViewTimeoutRef = (0,react.useRef)();

  var _useState5 = (0,react.useState)(false),
      showVideo = _useState5[0],
      setShowVideo = _useState5[1];

  var showVideoRef = (0,react.useRef)(false);

  var _useState6 = (0,react.useState)(false),
      videoIsLoaded = _useState6[0],
      setVideoIsLoaded = _useState6[1];

  var key = (0,use_new_key_on_window_resize/* default */.Z)();
  var observerRef = (0,react.useRef)();

  var handleClick = function handleClick() {
    if (portfolioItemClicked) return;
    setTimeout(function () {
      router.push("/work/".concat(slug.current));
    }, isMobile ? Transition/* TRANSITION_TIME_MS */.$r * 0.5 : 0);
    setPortfolioItemClicked(true);
    setPortfolioItemHoverIndex(patternIndex);
  }; // On click


  (0,react.useEffect)(function () {
    if (!portfolioItemClicked || !containerRef.current) return;
    var isSelected = patternIndex === portfolioItemHoverIndex;
    gsap/* default.to */.ZP.to(containerRef.current, {
      autoAlpha: 0,
      delay: isSelected ? Transition/* TRANSITION_TIME */.aV * 0.5 : 0,
      duration: Transition/* TRANSITION_TIME */.aV
    });
  }, [portfolioItemClicked, patternIndex, portfolioItemHoverIndex, router]);
  var animateCardsInInitial = (0,react.useCallback)(function () {
    var isValid = index < ANIMATE_UP_UNTIL_INDEX;
    if (prevPath) return;

    if (!isValid) {
      gsap/* default.set */.ZP.set(innerTransformContainerRef.current, {
        autoAlpha: 1
      });
    } else {
      gsap/* default.set */.ZP.set(innerTransformContainerRef.current, {
        y: '100vh',
        x: "".concat(gsap/* default.utils.random */.ZP.utils.random(-20, 20), "%"),
        scale: 1.2,
        rotate: gsap/* default.utils.random */.ZP.utils.random(-80, 80)
      });
    }
  }, [index, prevPath]);
  var animateCardsIn = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var isValid, delay;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (innerTransformContainerRef.current) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            isValid = index < ANIMATE_UP_UNTIL_INDEX;
            delay = index * 0.09 + 0.5;

            if (!prevPath) {
              _context.next = 7;
              break;
            }

            setAnimateInComplete(true);
            return _context.abrupt("return", gsap/* default.to */.ZP.to(innerTransformContainerRef.current, {
              duration: Transition/* TRANSITION_TIME */.aV,
              delay: isValid ? delay : 0
            }));

          case 7:
            if (isValid) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return");

          case 9:
            gsap/* default.to */.ZP.to(innerTransformContainerRef.current, {
              x: 0,
              y: 0,
              scale: 1,
              rotate: '0deg',
              ease: 'Power4.easeOut',
              duration: 1.8,
              delay: delay,
              onComplete: function onComplete() {
                if (index === ANIMATE_UP_UNTIL_INDEX - 2) {
                  setAnimateInComplete(true);
                }
              }
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [index, setAnimateInComplete, prevPath]);
  (0,react.useEffect)(function () {
    if (!containerRef.current || !imageContainerInnerRef) return;

    if (scrollTriggerRef.current) {
      scrollTriggerRef.current.kill();
    }

    if (timelineRef.current) {
      timelineRef.current.kill();
    }

    timelineRef.current = gsap/* default.timeline */.ZP.timeline();
    var distance = breakpoint.name === 'mobile' ? 20 : 30;
    var multiplier = breakpoint.name === 'mobile' ? PARALLAX_SPEEDS_MOBILE : PARALLAX_SPEEDS;
    var y = "-".concat(distance * multiplier[patternIndex], "vh");
    timelineRef.current.fromTo(containerRef.current, {
      rotate: "".concat(gsap/* default.utils.random */.ZP.utils.random(-10, 10), "deg")
    }, {
      y: y,
      rotate: "".concat(gsap/* default.utils.random */.ZP.utils.random(-2, 2, 0.5), "deg"),
      ease: 'linear'
    }, 0);
    timelineRef.current.to(imageContainerInnerRef.current, {
      y: '20%',
      ease: 'linear'
    }, 0);
    scrollTriggerRef.current = new ScrollTrigger.ScrollTrigger({
      trigger: containerRef.current,
      start: 'top bottom',
      end: 'top top',
      scrub: 2,
      animation: timelineRef.current,
      scroller: ".".concat(Layout/* SCROLL_CONTAINER_CLASS */.mb),
      onToggle: function onToggle(self) {
        setIsInView(self.isActive);
      },
      onRefresh: function onRefresh() {
        setScrollTriggerIsSetup(true);
      }
    });
    return function () {
      if (scrollTriggerRef.current) {
        scrollTriggerRef.current.kill();
      }

      if (timelineRef.current) {
        timelineRef.current.kill();
      }
    };
  }, [key, patternIndex, breakpoint]); //Observe when in middle of viewport

  (0,react.useEffect)(function () {
    if (!containerRef.current || !isMobile) return;

    if (observerRef.current) {
      observerRef.current.disconnect();
    }

    observerRef.current = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setCenteredPortfolioItemIndex(index);
        }
      });
    }, {
      rootMargin: '-50% 0% -50% 0%',
      threshold: 0
    });
    observerRef.current.observe(containerRef.current);
    return function () {
      observerRef.current.disconnect();
    };
  }, [isMobile, setCenteredPortfolioItemIndex, index]); // eslint-disable-next-line

  var animateExplicitBadge = function animateExplicitBadge(animateIn) {
    if (!explicitBadgeRef.current) return;

    if (explicitBadgeTimelineRef.current) {
      explicitBadgeTimelineRef.current.kill();
    }

    explicitBadgeTimelineRef.current = gsap/* default.timeline */.ZP.timeline({
      paused: true,
      onStart: function onStart() {
        gsap/* default.set */.ZP.set(explicitBadgeRef.current, {
          autoAlpha: 1
        });
      },
      onComplete: function onComplete() {
        if (animateIn) {
          gsap/* default.set */.ZP.set(explicitBadgeRef.current, {
            autoAlpha: 0
          });
        }
      }
    });
    var scales = [];

    for (var _index = 0; _index < 7; _index++) {
      scales.push(gsap/* default.utils.random */.ZP.utils.random(0.2, 1.8, 0.1));
    }

    scales.forEach(function (scale, i) {
      var _5 = gsap/* default.utils.random */.ZP.utils.random(0, 5);

      var _100 = gsap/* default.utils.random */.ZP.utils.random(90, 100);

      var _75 = gsap/* default.utils.random */.ZP.utils.random(60, 85);

      var _50 = gsap/* default.utils.random */.ZP.utils.random(40, 65);

      var isLastItem = i === scales.length - 1;
      /* eslint-disable */

      explicitBadgeTimelineRef.current.set(explicitBadgeRef.current, {
        scale: isLastItem ? 1 : scale,
        rotate: isLastItem ? '0deg' : "".concat(gsap/* default.utils.random */.ZP.utils.random(-20, 20), "deg"),
        scaleX: isLastItem ? 0 : gsap/* default.utils.random */.ZP.utils.random(0.9, 1.2),
        scaleY: isLastItem ? 0 : gsap/* default.utils.random */.ZP.utils.random(0.9, 1.2),
        clipPath: isLastItem ? 'none' : "polygon(".concat(_5, "% ").concat(gsap/* default.utils.random */.ZP.utils.random(5, 50), "%, ").concat(_100, "% 0%, ").concat(_75, "% ").concat(_75, "%, ").concat(_75, "% ").concat(_50, "%, ").concat(_50, "% ").concat(_100, "%, ").concat(_50, "% ").concat(_50, "%, 0% ").concat(_100, "%)")
      }, i * 0.05);
      /* eslint-enable */
    });

    if (animateIn) {
      explicitBadgeTimelineRef.current.play();
    } else {
      explicitBadgeTimelineRef.current.reverse();
      explicitBadgeTimelineRef.current.play();
    }
  };

  (0,react.useEffect)(function () {
    animateExplicitBadge(isHovering);
  }, [isHovering]);
  (0,react.useEffect)(function () {
    if (!scrollTriggerIsSetup) return;

    if (pageState === 'in') {
      animateCardsInInitial();
      animateCardsIn();
    }
  }, [pageState, scrollTriggerIsSetup, animateCardsIn, animateCardsInInitial, index]);
  (0,react.useEffect)(function () {
    if (!titleContainerRef.current || !metaDataRef.current || !metaDataBgRef.current) return;

    if (breakpoint.name === 'tablet' || breakpoint.name === 'mobile') {
      gsap/* default.set */.ZP.set([metaDataBgRef.current, titleContainerRef.current, metaDataRef.current], {
        clearProps: 'all'
      });
      return;
    }

    if (isHovering && tickerRef.current) {
      tickerRef.current.reset();
    }

    gsap/* default.killTweensOf */.ZP.killTweensOf([titleContainerRef.current, metaDataRef.current, metaDataBgRef.current]);
    gsap/* default.to */.ZP.to([metaDataBgRef.current, titleContainerRef.current, metaDataRef.current], {
      y: isHovering ? '100%' : '0',
      duration: isHovering ? 0.6 : 0.3,
      stagger: isHovering ? 0.1 : 0,
      ease: 'Power3.easeOut',
      autoAlpha: isHovering ? 1 : 0,
      onComplete: function onComplete() {
        if (!isHovering && tickerRef.current) {
          tickerRef.current.setIsRunning(false);
        }
      }
    });
    if (!imageScaleRef.current) return;
    gsap/* default.killTweensOf */.ZP.killTweensOf(imageScaleRef.current);
    gsap/* default.to */.ZP.to(imageScaleRef.current, {
      scale: isHovering ? 1.1 : 1,
      ease: 'Power3.easeOut',
      duration: isHovering ? 2 : 0.6
    });
  }, [isHovering, breakpoint, pageState]);
  (0,react.useEffect)(function () {
    if (!innerTransformContainerRef.current || !animateInComplete) return;
    gsap/* default.killTweensOf */.ZP.killTweensOf(innerTransformContainerRef.current);
    var isActive = portfolioItemHoverIndex === patternIndex;
    var autoAlpha = portfolioItemHoverIndex === false ? 1 : isActive ? 1 : 0.3;

    if (pageState === 'out') {
      autoAlpha = 0;
    }

    gsap/* default.to */.ZP.to(innerTransformContainerRef.current, {
      autoAlpha: autoAlpha,
      ease: 'Power4.easeOut',
      duration: 1
    });
  }, [patternIndex, portfolioItemHoverIndex, animateInComplete, pageState]);
  (0,react.useEffect)(function () {
    setTimeout(function () {
      if (!metaDataTitleContainerRef.current || !titleRef.current || !metaDataRef.current) return;
      var titleWidth = titleRef.current.offsetWidth;
      var metaDataWidth = metaDataRef.current.offsetWidth;
      var metaDataTitleContainerWidth = metaDataTitleContainerRef.current.offsetWidth;
      var room = metaDataTitleContainerWidth - metaDataWidth;
      var isLarger = titleWidth > room;
      setHasTicker(isLarger);
      setTimeout(function () {
        if (tickerRef.current) {
          tickerRef.current.setIsRunning(true);
        }
      }, 50);
    }, 100);
  }, [key, setHasTicker, slug, index]);
  (0,react.useEffect)(function () {
    var scrollContainer = document.querySelectorAll(".".concat(Layout/* SCROLL_CONTAINER_CLASS */.mb))[0];
    if (!(prevPath !== null && prevPath !== void 0 && prevPath.includes(slug.current)) || !scrollContainer) return;
    var offsetTop = containerRef.current.offsetTop;
    var scrollTo = offsetTop - window.innerHeight * 0.5;
    scrollContainer.scrollTo(0, scrollTo);
  }, [slug, prevPath]);
  (0,react.useEffect)(function () {
    if (tickerRef.current && (breakpoint.name === 'tablet' || breakpoint.name === 'mobile')) {
      if (isInView) {
        tickerRef.current.setIsRunning(true);
        tickerRef.current.reset();
      } else {
        tickerRef.current.setIsRunning(false);
      }
    }
  }, [isInView, breakpoint.name]);
  (0,react.useEffect)(function () {
    showVideoRef.current = showVideo;
  }, [showVideo]);
  (0,react.useEffect)(function () {
    if (!videoUrl || !videoRef.current) return;

    if (videoInViewTimeoutRef.current) {
      clearTimeout(videoInViewTimeoutRef.current);
    }

    var handler = function handler() {
      setVideoIsLoaded(true);
    };

    videoRef.current.removeEventListener('canplaythrough', handler); // desktop vs mobile conditions

    var condition = isInView;

    if (isMobile) {
      condition = isInView && centeredPortfolioItemIndex === index;
    }

    if (condition) {
      if (!showVideoRef.current) {
        videoInViewTimeoutRef.current = setTimeout(function () {
          if (videoRef.current) {
            setShowVideo(true);
            setTimeout(function () {
              videoRef.current.src = videoUrl;
              videoRef.current.currentTime = 0;
              videoRef.current.addEventListener('canplaythrough', handler);
            }, 50);
          }
        }, isMobile ? 200 : 1000);
      }
    } else {
      videoRef.current.src = '';
      videoRef.current.removeEventListener('canplaythrough', handler);
      videoRef.current.pause();
      setShowVideo(false);
      setVideoIsLoaded(false);
      gsap/* default.set */.ZP.set(videoRef.current, {
        clearProps: 'all'
      });
    }
  }, [isInView, videoIsLoaded, centeredPortfolioItemIndex, index, isMobile, videoUrl]);
  (0,react.useEffect)(function () {
    if (!videoRef.current || !videoIsLoaded) return;
    videoRef.current.play();
    gsap/* default.to */.ZP.to(videoRef.current, {
      autoAlpha: 1,
      duration: 0.8
    });
  }, [videoIsLoaded]);
  if (!slug || !title || !thumbnailOptions || !(thumbnailOptions !== null && thumbnailOptions !== void 0 && thumbnailOptions.image)) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("article", {
    className: classnames_default()((PortfolioItemThumbnail_module_default()).PortfolioItemThumbnail, className, (0,defineProperty/* default */.Z)({}, (PortfolioItemThumbnail_module_default())[thumbnailOptions.imageSize], thumbnailOptions.imageSize), (0,defineProperty/* default */.Z)({}, (PortfolioItemThumbnail_module_default()).isHovered, portfolioItemHoverIndex === patternIndex)),
    "data-type": type,
    ref: containerRef,
    onMouseEnter: function onMouseEnter() {
      if (breakpoint === 'mobile') return;
      setCursorType('hoverThumbnail');
      setPortfolioItemHoverIndex(patternIndex);
      setIsHovering(true);

      if (tickerRef.current) {
        tickerRef.current.setIsRunning(true);
      }
    },
    onMouseLeave: function onMouseLeave() {
      if (breakpoint === 'mobile') return;
      setCursorType(null);
      setPortfolioItemHoverIndex(false);
      setIsHovering(false);
    },
    style: {
      '--content-width': "".concat(contentRef.current ? contentRef.current.offsetWidth : 0, "px"),
      '--content-height': "".concat(contentRef.current ? contentRef.current.offsetHeight : 0, "px"),
      '--aspect-ratio': "".concat(contentRef.current ? "".concat(contentRef.current.offsetWidth, " / ").concat(contentRef.current.offsetHeight) : '1 / 1')
    },
    onClick: handleClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (PortfolioItemThumbnail_module_default()).hoverTransformContainer,
      ref: innerTransformContainerRef,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (PortfolioItemThumbnail_module_default()).inner,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (PortfolioItemThumbnail_module_default()).content,
          ref: contentRef,
          children: [hasExplicitContent && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: explicit.src,
            width: 100,
            height: 100,
            alt: "Explicit Content",
            className: (PortfolioItemThumbnail_module_default()).explicitBadge,
            ref: explicitBadgeRef
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (PortfolioItemThumbnail_module_default()).imageContainer,
            ref: imageContainerRef,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (PortfolioItemThumbnail_module_default()).imageContainer__inner,
              ref: imageContainerInnerRef,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                ref: imageScaleRef,
                className: (PortfolioItemThumbnail_module_default()).imageContainer__scaleContainer,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SanityImage/* default */.Z, {
                  image: thumbnailOptions.image,
                  breakpoints: [{
                    breakpoint: '1440',
                    image: thumbnailOptions.image,
                    width: 1000
                  }, {
                    breakpoint: '768',
                    image: thumbnailOptions.image,
                    width: 800
                  }, {
                    breakpoint: '0',
                    image: thumbnailOptions.image,
                    width: 500
                  }],
                  unoptimized: true,
                  className: (PortfolioItemThumbnail_module_default()).image
                }), videoUrl && /*#__PURE__*/(0,jsx_runtime.jsx)("video", {
                  muted: true,
                  playsInline: true,
                  loop: true,
                  autoPlay: true,
                  className: (PortfolioItemThumbnail_module_default()).video,
                  ref: videoRef
                })]
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (PortfolioItemThumbnail_module_default()).metaDataTitleContainer,
            ref: metaDataTitleContainerRef,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (PortfolioItemThumbnail_module_default()).metaDataBg,
              ref: metaDataBgRef
            }), hasTicker && isInView ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              ref: titleContainerRef,
              className: (PortfolioItemThumbnail_module_default()).titleContainer,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Ticker/* default */.Z, {
                className: (PortfolioItemThumbnail_module_default()).titleTicker,
                ref: tickerRef,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (PortfolioItemThumbnail_module_default()).title,
                  children: title
                })
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              ref: titleContainerRef,
              className: (PortfolioItemThumbnail_module_default()).titleContainer,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (PortfolioItemThumbnail_module_default()).title,
                ref: titleRef,
                children: title
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              ref: metaDataRef,
              className: (PortfolioItemThumbnail_module_default()).metaData,
              children: [type === 'video' && videoLength && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: videoLength
              }), type === 'gallery' && (images === null || images === void 0 ? void 0 : images.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: ["/ ", images.length]
              })]
            })]
          })]
        })
      })
    })
  });
};

PortfolioItemThumbnail.displayName = 'PortfolioItemThumbnail';
/* harmony default export */ var PortfolioItemThumbnail_PortfolioItemThumbnail = (PortfolioItemThumbnail);
// EXTERNAL MODULE: ./components/_modules/HomeSettings/LogoContainer/LogoContainer.module.scss
var LogoContainer_module = __webpack_require__(2403);
var LogoContainer_module_default = /*#__PURE__*/__webpack_require__.n(LogoContainer_module);
;// CONCATENATED MODULE: ./components/_modules/HomeSettings/LogoContainer/LogoContainer.js













var LogoContainer = function LogoContainer(_ref) {
  var className = _ref.className,
      desktopLogo = _ref.desktopLogo,
      desktopLogoHover = _ref.desktopLogoHover,
      isHover = _ref.isHover;

  var _usePageTransition = (0,use_page_transition/* default */.Z)(),
      pageState = _usePageTransition.pageState;

  var portfolioItemHoverIndex = (0,store/* default */.ZP)(function (state) {
    return state.portfolioItemHoverIndex;
  });
  var portfolioItemClicked = (0,store/* default */.ZP)(function (state) {
    return state.portfolioItemClicked;
  });
  var containerRef = (0,react.useRef)();

  var _useBreakpoint = (0,use_breakpoint/* default */.Z)(),
      isMobile = _useBreakpoint.isMobile;

  var animateInit = (0,react.useCallback)(function () {
    gsap/* default.killTweensOf */.ZP.killTweensOf(containerRef.current);
    gsap/* default.set */.ZP.set(containerRef.current, {
      autoAlpha: 0,
      y: '-100%'
    });
  }, []);
  (0,react.useEffect)(function () {
    if (!containerRef.current) return;

    if (pageState === 'in' && !portfolioItemClicked) {
      animateInit();
      gsap/* default.to */.ZP.to(containerRef.current, {
        autoAlpha: 1,
        y: 0,
        ease: 'Power3.easeOut',
        duration: Transition/* TRANSITION_TIME */.aV
      });
    } else {
      gsap/* default.to */.ZP.to(containerRef.current, {
        autoAlpha: 0,
        duration: Transition/* TRANSITION_TIME */.aV * 0.5,
        delay: isMobile ? 0 : Transition/* TRANSITION_TIME */.aV * 0.5
      });
    }
  }, [pageState, animateInit, isMobile, portfolioItemClicked]);
  if (!desktopLogo || !desktopLogoHover) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()((LogoContainer_module_default()).LogoContainer, className, (0,defineProperty/* default */.Z)({}, (LogoContainer_module_default()).isHover, isHover || portfolioItemHoverIndex !== false)),
    ref: containerRef,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SanityImage/* default */.Z, {
      className: classnames_default()((LogoContainer_module_default()).logo, (LogoContainer_module_default()).desktop),
      image: desktopLogo,
      breakpoints: [{
        breakpoint: 768,
        image: desktopLogo,
        width: 3400
      }],
      unoptimized: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SanityImage/* default */.Z, {
      className: classnames_default()((LogoContainer_module_default()).logo, (LogoContainer_module_default()).desktop, (LogoContainer_module_default()).hoverLogo),
      image: desktopLogoHover,
      breakpoints: [{
        breakpoint: 768,
        image: desktopLogoHover,
        width: 3400
      }],
      unoptimized: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SanityImage/* default */.Z, {
      className: classnames_default()((LogoContainer_module_default()).logo, (LogoContainer_module_default()).mobile),
      image: desktopLogo,
      breakpoints: [{
        breakpoint: 420,
        image: desktopLogo,
        width: 800
      }, {
        breakpoint: 1,
        image: desktopLogo,
        width: 500
      }],
      unoptimized: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SanityImage/* default */.Z, {
      className: classnames_default()((LogoContainer_module_default()).logo, (LogoContainer_module_default()).mobile, (LogoContainer_module_default()).hoverLogo),
      image: desktopLogoHover,
      breakpoints: [{
        breakpoint: 420,
        image: desktopLogoHover,
        width: 800
      }, {
        breakpoint: 1,
        image: desktopLogoHover,
        width: 500
      }],
      unoptimized: true
    })]
  });
};

LogoContainer.displayName = 'LogoContainer';
/* harmony default export */ var LogoContainer_LogoContainer = (LogoContainer);
;// CONCATENATED MODULE: ./components/_modules/HomeSettings/PortfolioItemScroller/PortfolioItemScroller.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var PortfolioItemScroller = function PortfolioItemScroller(_ref) {
  var className = _ref.className,
      items = _ref.portfolioItems,
      logoSettings = _ref.logoSettings;

  // const portfolioItems = [...items, ...items, ...items, ...items, ...items, ...items, ...items]
  var portfolioItems = (0,toConsumableArray/* default */.Z)(items);

  var scrollerRef = (0,react.useRef)();
  var scrollerContentRef = (0,react.useRef)();
  var setPortfolioItemHoverIndex = (0,store/* default */.ZP)(function (state) {
    return state.setPortfolioItemHoverIndex;
  });
  var setPortfolioItemClicked = (0,store/* default */.ZP)(function (state) {
    return state.setPortfolioItemClicked;
  });

  var _useState = (0,react.useState)(false),
      animateInComplete = _useState[0],
      setAnimateInComplete = _useState[1];

  var _usePageTransition = (0,use_page_transition/* default */.Z)(),
      pageState = _usePageTransition.pageState;

  var animateInit = function animateInit() {
    if (!scrollerRef.current) return;
    gsap/* default.set */.ZP.set(scrollerRef.current, {
      autoAlpha: 0
    });
  };

  var animateIn = function animateIn() {
    if (!scrollerRef.current) return;
    gsap/* default.to */.ZP.to(scrollerRef.current, {
      autoAlpha: 1,
      duration: Transition/* TRANSITION_TIME */.aV,
      delay: 0.3
    });
  };

  (0,react.useEffect)(function () {
    return function () {
      setPortfolioItemHoverIndex(false);
      setPortfolioItemClicked(false);
    };
  }, [setPortfolioItemHoverIndex, setPortfolioItemClicked]);
  (0,react.useEffect)(function () {
    if (pageState === 'in') {
      animateInit();
      animateIn();
    }
  }, [pageState]);
  if (!portfolioItems.length) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: classnames_default()((PortfolioItemScroller_module_default()).PortfolioItemScroller, className, (0,defineProperty/* default */.Z)({}, (PortfolioItemScroller_module_default()).animateInComplete, animateInComplete)),
    style: {
      '--number-of-items': portfolioItems.length
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      ref: scrollerRef,
      className: (PortfolioItemScroller_module_default()).scrollerOverflowContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (PortfolioItemScroller_module_default()).scrollerContentContainer,
        ref: scrollerContentRef,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (PortfolioItemScroller_module_default()).scrollList,
          children: [portfolioItems.map(function (item, i) {
            var _item$thumbnailOption, _item$thumbnailOption2, _item$thumbnailOption3, _item$thumbnailOption4, _item$thumbnailOption5, _item$thumbnailOption6;

            return /*#__PURE__*/(0,jsx_runtime.jsx)(PortfolioItemThumbnail_PortfolioItemThumbnail, {
              animateInComplete: animateInComplete,
              setAnimateInComplete: setAnimateInComplete,
              className: (PortfolioItemScroller_module_default()).scrollList__item,
              index: i,
              slug: item.slug,
              title: item.title,
              hasExplicitContent: item.hasExplicitContent,
              thumbnailOptions: item.thumbnailOptions,
              videoUrl: (item === null || item === void 0 ? void 0 : (_item$thumbnailOption = item.thumbnailOptions) === null || _item$thumbnailOption === void 0 ? void 0 : (_item$thumbnailOption2 = _item$thumbnailOption.videoLoop) === null || _item$thumbnailOption2 === void 0 ? void 0 : (_item$thumbnailOption3 = _item$thumbnailOption2.asset) === null || _item$thumbnailOption3 === void 0 ? void 0 : _item$thumbnailOption3.size) < 1250000 ? item === null || item === void 0 ? void 0 : (_item$thumbnailOption4 = item.thumbnailOptions) === null || _item$thumbnailOption4 === void 0 ? void 0 : (_item$thumbnailOption5 = _item$thumbnailOption4.videoLoop) === null || _item$thumbnailOption5 === void 0 ? void 0 : (_item$thumbnailOption6 = _item$thumbnailOption5.asset) === null || _item$thumbnailOption6 === void 0 ? void 0 : _item$thumbnailOption6.url : null,
              type: item === null || item === void 0 ? void 0 : item.type,
              images: item === null || item === void 0 ? void 0 : item.images,
              videoFileUrl: item === null || item === void 0 ? void 0 : item.videoFileUrl,
              videoLength: item === null || item === void 0 ? void 0 : item.videoLength
            }, i);
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(LogoContainer_LogoContainer, _objectSpread({}, logoSettings))]
        })
      })
    })
  });
};

PortfolioItemScroller.displayName = 'PortfolioItemScroller';
/* harmony default export */ var PortfolioItemScroller_PortfolioItemScroller = (PortfolioItemScroller);
// EXTERNAL MODULE: ./components/_modules/HomeSettings/HomeSettings.module.scss
var HomeSettings_module = __webpack_require__(5090);
var HomeSettings_module_default = /*#__PURE__*/__webpack_require__.n(HomeSettings_module);
;// CONCATENATED MODULE: ./components/_modules/HomeSettings/HomeSettings.js


function HomeSettings_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function HomeSettings_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? HomeSettings_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HomeSettings_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var HomeSettings = function HomeSettings(_ref) {
  var aboutModal = _ref.aboutModal,
      contact = _ref.contact,
      logoSettings = _ref.logoSettings,
      footer = _ref.footer,
      portfolioItems = _ref.portfolioItems;

  var _usePageTransition = (0,use_page_transition/* default */.Z)(),
      pageState = _usePageTransition.pageState;

  var contactButtonRef = (0,react.useRef)();
  var aboutButtonRef = (0,react.useRef)();

  var _useState = (0,react.useState)(false),
      aboutModalIsOpen = _useState[0],
      setAboutModalIsOpen = _useState[1];

  (0,react.useEffect)(function () {
    if (!contactButtonRef.current || !aboutButtonRef.current) return;

    if (pageState === 'in') {
      gsap/* default.fromTo */.ZP.fromTo([contactButtonRef.current, aboutButtonRef.current], {
        y: -50,
        autoAlpha: 0
      }, {
        y: 0,
        autoAlpha: 1,
        duration: Transition/* TRANSITION_TIME */.aV * 0.5,
        delay: Transition/* TRANSITION_TIME */.aV
      });
    } else {
      gsap/* default.to */.ZP.to([contactButtonRef.current, aboutButtonRef.current], {
        autoAlpha: 0,
        y: -50,
        duration: Transition/* TRANSITION_TIME */.aV * 0.5
      });
    }
  }, [pageState]);
  if (!aboutModal || !contact || !logoSettings || !portfolioItems.length) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (HomeSettings_module_default()).HomeSettings,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AboutModal_AboutModal, HomeSettings_objectSpread(HomeSettings_objectSpread({}, aboutModal), {}, {
      aboutModalIsOpen: aboutModalIsOpen,
      setAboutModalIsOpen: setAboutModalIsOpen
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer_Footer, HomeSettings_objectSpread({}, footer)), (aboutModal === null || aboutModal === void 0 ? void 0 : aboutModal.buttonText) && /*#__PURE__*/(0,jsx_runtime.jsx)(PillButton/* default */.Z, {
      ariaLabel: "Open About Modal",
      label: aboutModal === null || aboutModal === void 0 ? void 0 : aboutModal.buttonText,
      className: (HomeSettings_module_default()).aboutButton,
      theme: "red",
      onClick: function onClick() {
        setAboutModalIsOpen(function (prev) {
          return !prev;
        });
      },
      elementRef: aboutButtonRef
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: "mailto:".concat(contact.email),
      className: (HomeSettings_module_default()).contactButton,
      ref: contactButtonRef,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PillButton/* default */.Z, {
        theme: "purple",
        element: "span",
        label: "Contact"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PortfolioItemScroller_PortfolioItemScroller, {
      logoSettings: logoSettings,
      portfolioItems: portfolioItems
    })]
  });
};

HomeSettings.displayName = 'HomeSettings';
/* harmony default export */ var HomeSettings_HomeSettings = (HomeSettings);
;// CONCATENATED MODULE: ./components/Sections/Sections.js


function Sections_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Sections_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Sections_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Sections_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* INJECT_SECTIONS_IMPORT */



var MODULES = {
  /* INJECT_SECTIONS_TYPE */
  homeSettings: HomeSettings_HomeSettings
};

function Sections(_ref) {
  var modules = _ref.modules;
  if (!(modules !== null && modules !== void 0 && modules.length)) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: modules.map(function (moduleArr, i) {
      if (!(moduleArr !== null && moduleArr !== void 0 && moduleArr.module)) {
        console.warn('No modules tied to data ', moduleArr);
        return null;
      }

      var moduleObj = moduleArr === null || moduleArr === void 0 ? void 0 : moduleArr.module[0];

      if (!MODULES[moduleObj._type]) {
        console.warn('No module found with type ', moduleObj._type);
        return null;
      }

      if (moduleObj.cmsSettings.isHidden) {
        return null;
      }

      var ModuleComponent = MODULES[moduleObj._type];
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ModuleComponent, Sections_objectSpread({}, moduleObj), "".concat(i, "_").concat(moduleObj._key));
    })
  });
}

/* harmony default export */ var Sections_Sections = (Sections);

/***/ }),

/***/ 9775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_ticker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2093);
/* harmony import */ var _Ticker_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3648);
/* harmony import */ var _Ticker_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Ticker_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6911);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);






var AutoScroller = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      _children = _ref.children,
      speed = _ref.speed;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      isRunning = _useState[0],
      setIsRunning = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      showTicker = _useState2[0],
      setShowTicker = _useState2[1];

  var windowInFocusKey = (0,store__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function (state) {
    return state.windowInFocusKey;
  });

  var reset = function reset() {
    setShowTicker(false);
    setTimeout(function () {
      setShowTicker(true);
    }, 5);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, function () {
    return {
      setIsRunning: setIsRunning,
      reset: reset
    };
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    reset();
  }, [windowInFocusKey]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Ticker_module_scss__WEBPACK_IMPORTED_MODULE_5___default().Ticker), className),
    children: showTicker && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_ticker__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      speed: speed,
      move: isRunning,
      children: function children() {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          children: _children
        });
      }
    })
  });
});
AutoScroller.displayName = 'AutoScroller';
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(AutoScroller));

/***/ }),

/***/ 694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var styles_export_vars_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(763);
/* harmony import */ var styles_export_vars_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styles_export_vars_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _use_new_key_on_window_resize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2143);



var BREAKPOINTS = {
  mobile: styles_export_vars_module_scss__WEBPACK_IMPORTED_MODULE_2__.mobile,
  tablet: styles_export_vars_module_scss__WEBPACK_IMPORTED_MODULE_2__.tablet,
  laptop: styles_export_vars_module_scss__WEBPACK_IMPORTED_MODULE_2__.laptop,
  desktop: styles_export_vars_module_scss__WEBPACK_IMPORTED_MODULE_2__.desktop,
  xl: styles_export_vars_module_scss__WEBPACK_IMPORTED_MODULE_2__.xl
};

var getBreakpointByWidth = function getBreakpointByWidth(windowWidth) {
  var breakpoint = null;
  Object.values(BREAKPOINTS).forEach(function (bpValue, i) {
    var bp = parseInt(bpValue);
    var beginningSize = i === 0 ? 0 : parseInt(Object.values(BREAKPOINTS)[i - 1]);
    var endingSize = i === Object.values(BREAKPOINTS).length - 1 ? 10000 : bp;

    if (windowWidth > beginningSize && windowWidth <= endingSize) {
      breakpoint = {
        name: Object.keys(BREAKPOINTS)[i],
        width: windowWidth
      };
    }
  });
  return breakpoint;
};

function useBreakpoint() {
  var key = (0,_use_new_key_on_window_resize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(100);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      breakpoint = _useState[0],
      setBreakpoint = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var bp = getBreakpointByWidth(window.innerWidth);
    setBreakpoint(bp);
  }, [key]);
  return {
    breakpoint: breakpoint,
    isMobile: (breakpoint === null || breakpoint === void 0 ? void 0 : breakpoint.name) === 'mobile'
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (useBreakpoint);

/***/ }),

/***/ 7073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePageTransition; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var components_Transition_Transition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6662);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



function usePageTransition() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(components_Transition_Transition__WEBPACK_IMPORTED_MODULE_1__/* .TransitionContext */ .qN),
      url = _useContext.url,
      isPageLoaded = _useContext.isPageLoaded;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  var isIn = url === router.asPath;
  return {
    pageState: isIn && isPageLoaded ? 'in' : 'out',
    isPageLoaded: isPageLoaded
  };
}

/***/ }),

/***/ 2030:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 502:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PillButton":"PillButton_PillButton__ubhse","infoButton":"PillButton_infoButton__Sr134","red":"PillButton_red__vhmEi","purple":"PillButton_purple__kLakw","white":"PillButton_white__8w1mB","text":"PillButton_text__L_b_u","textHover":"PillButton_textHover__MZ1jk","infoIcon":"PillButton_infoIcon__udyic"};

/***/ }),

/***/ 7014:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RichText":"RichText_RichText__MS6qM","highlighted":"RichText_highlighted__iyhc3","displayText":"RichText_displayText__Cft_r"};

/***/ }),

/***/ 3648:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Ticker":"Ticker_Ticker__PLMDZ","disableHover":"Ticker_disableHover__jA1yL"};

/***/ }),

/***/ 6914:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AboutModal":"AboutModal_AboutModal__PbRBT","inner":"AboutModal_inner__Eh55Y","innerScroll":"AboutModal_innerScroll__axWK2","close":"AboutModal_close__nPjnA","rta":"AboutModal_rta__CRElx","peopleContainer":"AboutModal_peopleContainer__B_6jj","peopleTitle":"AboutModal_peopleTitle__0MQ3l","peopleList":"AboutModal_peopleList__TAkkZ","peopleList__item":"AboutModal_peopleList__item__ab60u","imageContainer":"AboutModal_imageContainer__NXKPT","image":"AboutModal_image__DzxQi","contactMethods":"AboutModal_contactMethods__kWoxk","contactMethods__method":"AboutModal_contactMethods__method__hN_h8","contactMethods__type":"AboutModal_contactMethods__type__PRou9","contactMethods__value":"AboutModal_contactMethods__value__dOt2K","aboutModalBg":"AboutModal_aboutModalBg__trm_x"};

/***/ }),

/***/ 4471:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__OxM2R","isHovering":"Footer_isHovering__4vL1M","brand":"Footer_brand__qEe2A","longText":"Footer_longText__jLHb5","copyright":"Footer_copyright__VHDui"};

/***/ }),

/***/ 5090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contactButton":"HomeSettings_contactButton__6rcFp","aboutButton":"HomeSettings_aboutButton__vhG4k"};

/***/ }),

/***/ 2403:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"LogoContainer":"LogoContainer_LogoContainer__S1cpR","logo":"LogoContainer_logo__TnCI9","hoverLogo":"LogoContainer_hoverLogo__CdN_Z","desktop":"LogoContainer_desktop__mEnr5","mobile":"LogoContainer_mobile__yYaH_","isHover":"LogoContainer_isHover__AfvBt"};

/***/ }),

/***/ 3522:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PortfolioItemScroller":"PortfolioItemScroller_PortfolioItemScroller__epai3","animateInComplete":"PortfolioItemScroller_animateInComplete__wRqhg","scrollList":"PortfolioItemScroller_scrollList__rqayJ","scrollList__item":"PortfolioItemScroller_scrollList__item__puV7J"};

/***/ }),

/***/ 61:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PortfolioItemThumbnail":"PortfolioItemThumbnail_PortfolioItemThumbnail__PFeD_","isHovered":"PortfolioItemThumbnail_isHovered__FdVzj","full":"PortfolioItemThumbnail_full__bD1nD","portrait":"PortfolioItemThumbnail_portrait__J6Wv2","square":"PortfolioItemThumbnail_square__xdqjr","inner":"PortfolioItemThumbnail_inner__UPkyn","content":"PortfolioItemThumbnail_content__myM0V","explicitBadge":"PortfolioItemThumbnail_explicitBadge__2S_sG","imageContainer":"PortfolioItemThumbnail_imageContainer__iHeYO","imageContainer__inner":"PortfolioItemThumbnail_imageContainer__inner__ZB6vw","imageContainer__scaleContainer":"PortfolioItemThumbnail_imageContainer__scaleContainer__YudCD","image":"PortfolioItemThumbnail_image__4Mids","video":"PortfolioItemThumbnail_video__Wmp46","metaDataTitleContainer":"PortfolioItemThumbnail_metaDataTitleContainer__SANuu","metaDataBg":"PortfolioItemThumbnail_metaDataBg__3C8mU","title":"PortfolioItemThumbnail_title__IsVbB","titleTicker":"PortfolioItemThumbnail_titleTicker__6FzVG","titleContainer":"PortfolioItemThumbnail_titleContainer__QQq2D","metaData":"PortfolioItemThumbnail_metaData__gu7SS"};

/***/ })

}]);